import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { FormControl, InputBase, Select, withStyles } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import {
  createMuiTheme,
  makeStyles,
  ThemeProvider,
} from '@material-ui/core/styles';

const OptionsSelection = (props) => {
  const { t, list, handleChange, selected, disabled, name, maxWidth } = props;
  const BootstrapInput = withStyles(() => ({
    input: {
      position: 'relative',
      backgroundColor: '#fff',
      padding: '5px 0px 0px 11px',
      fontSize: 13,
      maxHeight: 32,
      fontFamily: ['Roboto', 'sans-serif'].join(','),
    },
  }))(InputBase);

  const useStyles = makeStyles(() => ({
    formControl: {
      backgroundColor: '#fff',
      border: '1px solid #e0e1e2;',
      color: '#30313F',
      paddingBottom: '2px',
      height: '32px',
      width: '100%',
    },
    Select: {
      maxWidth,
      fontSize: 13,
      color: '#30313F',
      height: '2rem',
    },
    span: {
      color: '#808080',
    },
  }));

  const theme = createMuiTheme({
    overrides: {
      MuiSelect: {
        select: {
          '&:focus': {
            backgroundColor: '#fff',
            color: 'red',
          },
        },
      },
    },
  });

  const classes = useStyles();
  const menuList = list.map((item) => (
    <MenuItem key={item.value} value={item.value}>
      {item.label}
    </MenuItem>
  ));

  const onChangeSelected = (value) => {
    return list.find((item) => item.value === value);
  };

  return (
    <ThemeProvider theme={theme}>
      <FormControl
        name={name}
        variant="outlined"
        className={classes.formControl}
      >
        <Select
          displayEmpty
          input={<BootstrapInput />}
          className={classes.Select}
          disabled={disabled}
          value={selected.value}
          required
          renderValue={
            selected.value !== 0
              ? undefined
              : () => (
                  <span className={classes.span}>
                    {t('general.placeholders.select')}
                  </span>
                )
          }
          onChange={(event) =>
            handleChange(onChangeSelected(event.target.value))
          }
        >
          {menuList}
        </Select>
      </FormControl>
    </ThemeProvider>
  );
};

OptionsSelection.propTypes = {
  t: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  handleChange: PropTypes.func.isRequired,
  selected: PropTypes.shape(PropTypes.shape()),
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  maxWidth: PropTypes.number,
};
OptionsSelection.defaultProps = { maxWidth: undefined };

OptionsSelection.defaultProps = {
  selected: { value: 0 },
  disabled: false,
};

export default withTranslation('common')(memo(OptionsSelection));
